/*

	§title£ Module: Toggle§
	§description£ Descrizione <code>ui.toggle</code>§

*/

//	aria				// Classe o testo
//	ariaEvent			// Roll o Click (default)
//	ariaMode			// Text o Class (default)
//	ariaParent			// Ho la possibilità di definire un selettore per racchiudere la singola logica
						// all'interno di quel container e gestire il remove delle classi
						// quando faccio un click al di fuori di esso.
						// Deve essere un parent. Campo opzionale
// ariaCascade			// Se presente abilito la logica di apertura e chiusura automatica dei field vicini
// ariaEmulate			// Se presente simulo il click di un altro elemento
// ariaHideOnClickFrom	// Se effettuo un click al di fuori di un container impostato tramite l'attributo
						// Vado a toglire tutti i toggle attivi all'interno di quel container

// toggle_click(parent); Funzione globale che va ad eliminare tutte le classi attive partendo da un parent


let temp = [],
    queueClick = [],
    queueHover = [],
    ariaEmulate = '',
    string_toggle = 'js-toggle',
    hook_toggle = jQuery('.'+string_toggle),
    clickEvent = (function() {
        // Gestione click o touch (iPad bug)
        if ('ontouchstart' in document.documentElement === true) {
                return 'touchstart';
        } else {
                return 'click';
        }
    })();

// Click
jQuery(document).on(clickEvent, '.'+string_toggle, function(e){
	e.preventDefault();
	
	// Aggiorno il conteggio degli hook nel caso ne avessi generati altri
	hook_toggle = jQuery('.'+string_toggle);
	
    var context = jQuery(this);
	
	var aria = context.attr('data-toggle'),
		ariaEvent = context.attr('data-toggleEvent') ? context.attr('data-toggleEvent') : 'click',
		ariaMode = context.attr('data-toggleMode') ? context.attr('data-toggleMode') : 'class';
	
		ariaEmulate = context.attr('data-toggleEmulate') ? context : '';
	
	if(ariaEvent === 'click'){
		window.toggle_click = function(parent){
			if(hook_toggle.is(parent) && ariaMode === 'class' || hook_toggle.is(parent) && ariaMode === 'classe'){
                aria = parent.attr('data-toggle');
				if(body.hasClass(aria) && parent.hasClass('js-toggleItemActive')){
					parent.removeClass('js-toggleItemActive-class').parent().removeClass('js-toggleParentActive-class');

					queueClick.shift(aria);
					
					if(queueClick.length == 0 && jQuery('.' + string_toggle + '[data-toggle="' + aria + '"].js-toggleItemActive').length <= 0){
						body.removeClass('js-toggleBodyActive');
					}

					ariaEmulate = '';
					
                    // Transition
					setTimeout(function(){
                        // Se ho altri toggle con lo stesso attributo aria aspetto di disattivare l'ultimo per togliere la classe sul body
						if(jQuery('.' + string_toggle + '[data-toggle="' + aria + '"].js-toggleItemActive').length <= 0){
                            body.removeClass(aria);
						}

						// Nel caso ho degli hook attivi, figli di quello che sto spegnendo; li cerco, li pusho in un array temporaneo e li elimino al promise.
						parent.next().find('.js-toggleItemActive').each(function(){
							var local = jQuery(this);
							local.removeClass('js-toggleItemActive js-toggleItemActive-click js-toggleItemActive-class').parent().removeClass('js-toggleParentActive js-toggleParentActive-click js-toggleParentActive-class');

							if(jQuery.inArray(local.attr('data-toggle'),temp) < 0){
								temp.push(local.attr('data-toggle'));
							}
							queueClick.shift(local.attr('data-toggle'));

						}).promise().done(function(){
							// Stampo tutte le classi che ho trovato, le elimino da body e pulisco l'array
							var allClass = jQuery.map(temp, function(val) { return val; }).join(' ');
							body.removeClass(allClass);
							temp = [];
							
							if(queueClick.length == 0 && jQuery('.' + string_toggle + '[data-toggle="' + aria + '"].js-toggleItemActive').length <= 0){
								body.removeClass('js-toggleBodyActive');
							}
						});
					},transitionDuration);
				} else {
					body.addClass(aria);
					parent.addClass('js-toggleItemActive-class').parent().addClass('js-toggleParentActive-class');

					if(jQuery.inArray(aria,queueClick) < 0){
						queueClick.push(aria);
					}

					// Se l'elemento che ho cliccato è figlio indiretto di altri hook allora li vado ad attivare
					if(parent.parents().prev('.'+string_toggle).length > 0){
						var ancestor = parent.parents().prev('.'+string_toggle),
							cascade = false;
						
						ancestor.each(function(){
							var context = jQuery(this);
							if(context.attr('data-toggleCascade')){
								cascade = true;
							}
						}).promise().done(function(){
							if(cascade){
								ancestor.each(function(){
									var local = jQuery(this),
										localAria = local.attr('data-toggle');

									body.addClass(localAria);

									local.addClass('js-toggleItemActive-class').parent().addClass('js-toggleParentActive-class');

									if(jQuery.inArray(localAria,queueClick) < 0){
										queueClick.push(localAria);
									}
								});
							}
						});
					}

					// Transition
					setTimeout(function(){
						body.addClass('js-toggleBodyActive');

					},transitionDuration);
				}
			}
			
			// Le classi che vado ad applicare qui sono universali sia per Mode text che per Mode class
			if(parent.hasClass('js-toggleItemActive')){
				parent.removeClass('js-toggleItemActive js-toggleItemActive-click').parent().removeClass('js-toggleParentActive js-toggleParentActive-click');

				// Se l'elemento che ho cliccato è figlio indiretto di altri hook allora li vado a disattivare
				if(parent.parents().prev('.'+string_toggle).length > 0){
					var ancestor = parent.parents().prev('.'+string_toggle),
						cascade = false;

					ancestor.each(function(){
						var context = jQuery(this);
						if(context.attr('data-toggleCascade')){
							cascade = true;
						}
					}).promise().done(function(){
						if(cascade){
							ancestor.each(function(){
								var local = jQuery(this);
								local.removeClass('js-toggleItemActive js-toggleItemActive-click').parent().removeClass('js-toggleParentActive js-toggleParentActive-click');
							});
						}
					});
				}
			} else {
				parent.addClass('js-toggleItemActive js-toggleItemActive-click').parent().addClass('js-toggleParentActive js-toggleParentActive-click');

				// Se l'elemento che ho cliccato è figlio indiretto di altri hook allora li vado ad attivare
				if(parent.parents().prev('.'+string_toggle).length > 0){
					var ancestor = parent.parents().prev('.'+string_toggle),
						cascade = false;

					ancestor.each(function(){
						var context = jQuery(this);
						if(context.attr('data-toggleCascade')){
							cascade = true;
						}
					}).promise().done(function(){
						if(cascade){
							ancestor.each(function(){
								var local = jQuery(this);
								local.addClass('js-toggleItemActive js-toggleItemActive-click').parent().addClass('js-toggleParentActive js-toggleParentActive-click');
							});
						}
					});
				}
			}
		}
		
		if(context.attr('data-toggleEmulate')){
			var ariaToEmulate = context.attr('data-toggleEmulate');

			context = jQuery(ariaToEmulate),
			aria = context.attr('data-toggle'),
			ariaEvent = context.attr('data-toggleEvent') ? context.attr('data-toggleEvent') : 'click',
			ariaMode = context.attr('data-toggleMode') ? context.attr('data-toggleMode') : 'class';
		}
		
		toggle_click(context);
		
		if(hook_toggle.is(context) && ariaMode === 'text' || hook_toggle.is(context) && ariaMode === 'testo'){
			// Se l'hook ha figli, il testo lo sostituirò direttamente nell'ultimo figlio
			var ariaTextElement = context.children().length > 0 ? context.find(':last') : context;

			// Prelevo il testo originale
			var ariaOriginalText = ariaTextElement.html();

			if(context.hasClass('js-toggleItemActive-text')){
				context.removeClass('js-toggleItemActive-text').parent().removeClass('js-toggleParentActive-text');
				context.find(ariaTextElement).html(context.attr('data-toggleText'));
			} else {
				context.addClass('js-toggleItemActive-text').parent().addClass('js-toggleParentActive-text');
				context.attr('data-toggleText',ariaOriginalText).find(ariaTextElement).html(aria);
			}
		}
	}
});

// Cancello l'evento registrato precedentemente (nel caso ci sia) in modo tale da non accavallare i controlli
jQuery(document).on(clickEvent, function(e){
	var clickFrom = jQuery(e.target);

	hook_toggle.each(function(){
		var context = jQuery(this);

		if(context.attr('data-toggleHideOnClickFrom')){
			var aria = context.attr('data-toggle'),
				ariaEvent = context.attr('data-toggleEvent') ? context.attr('data-toggleEvent') : 'click',
				ariaMode = context.attr('data-toggleMode') ? context.attr('data-toggleMode') : 'class',
				ariaHideOnClickFrom = context.attr('data-toggleHideOnClickFrom');
			
			if(ariaEvent === 'click'){
				if(hook_toggle.is(context) && ariaMode === 'class' ||
				   hook_toggle.is(context) && ariaMode === 'classe'){
					if(!body.hasClass('js-toggleHideOnClickFrom-on') &&
					   !clickFrom.is(context) &&
					   !clickFrom.is(context.find('*')) &&
					   !clickFrom.is(jQuery(ariaHideOnClickFrom)) &&
					   !clickFrom.is(jQuery(ariaHideOnClickFrom).find('*')) &&
					   context.css('visibility') !== 'hidden'){

						// Ora valido che ariaEmulate esista e in quel caso controllo se ci sto cliccando dentro
						if(ariaEmulate === '' || !clickFrom.is(ariaEmulate) && !clickFrom.is(ariaEmulate.find('*'))){
							// Prendo in considerazione solamente i primi discendenti in modo tale da poter disattivare i relativi figli a cascata
							if(context.is(hook_toggle.filter(function() {
								return jQuery(this).parents('*:has(>.'+ string_toggle +':first-child)').length < 2;
							}))
							   && context.hasClass('js-toggleItemActive')){
								toggle_click(context);
							}
						}
					}
				}
			}
		}
	});
});

// Roll
hook_toggle.each(function(){
	var context = jQuery(this);
	
	var aria = context.attr('data-toggle'),
		ariaEvent = context.attr('data-toggleEvent') ? context.attr('data-toggleEvent') : 'click',
		ariaMode = context.attr('data-toggleMode') ? context.attr('data-toggleMode') : 'class';
	
	if(ariaEvent === 'roll' || ariaEvent === 'rollover' || ariaEvent === 'hover' || ariaEvent === 'mouseover'){
		// Genero una variabile per gestire la transizione se è un evento classe o testo (testo non ha transizione)
		var transition;
		
		function showHide(){
			if(context.hasClass('js-toggleItemActive')){
				context.removeClass('js-toggleItemActive js-toggleItemActive-roll').parent().removeClass('js-toggleParentActive js-toggleParentActive-roll');
			} else {
				context.addClass('js-toggleItemActive js-toggleItemActive-roll').parent().addClass('js-toggleParentActive js-toggleParentActive-roll');
			}
			
			if(hook_toggle.is(context) && ariaMode === 'class' || hook_toggle.is(context) && ariaMode === 'classe'){
				aria = context.attr('data-toggle');
				transition = transitionDuration;
				
				if(body.hasClass(aria)){
					context.removeClass('js-toggleItemActive-class').parent().removeClass('js-toggleParentActive-class');

					queueHover.shift(aria);

					if(queueHover.length == 0){
						body.removeClass('js-toggleBodyActive');
					}
					
					// Transition
					setTimeout(function(){
						body.removeClass(aria);
					},transitionDuration);
				} else {
					body.addClass(aria);
					context.addClass('js-toggleItemActive-class').parent().addClass('js-toggleParentActive-class');

					if(jQuery.inArray(aria,queueHover) < 0){
						queueHover.push(aria);
					}
					
					// Transition
					setTimeout(function(){
						body.addClass('js-toggleBodyActive');
					},transitionDuration);
				}
			} else if(hook_toggle.is(context) && ariaMode === 'text' || hook_toggle.is(context) && ariaMode === 'testo'){
				transition = 0;
				
				// Se l'hook ha figli, il testo lo sostituirò direttamente nell'ultimo figlio
				var ariaTextElement = context.children().length > 0 ? context.find(':last') : context;

				// Prelevo il testo originale
				var ariaOriginalText = ariaTextElement.html();

				if(context.hasClass('js-toggleItemActive-text')){
					context.removeClass('js-toggleItemActive-text').parent().removeClass('js-toggleParentActive-text');
					context.find(ariaTextElement).html(context.attr('data-toggleText'));
				} else {
					context.addClass('js-toggleItemActive-text').parent().addClass('js-toggleParentActive-text');
					context.attr('data-toggleText',ariaOriginalText).find(ariaTextElement).html(aria);
				}
			}
		}

		var timeout, parent = ariaMode === 'text' || ariaMode === 'testo' ? context : context.parent();
		
		// Per avere la possibilità di eseguire più hover insieme, devo applicare la funzione al parent...
		parent.hover(
			function() {
				// Entrata
				if(!timeout){
					timeout = setTimeout(function(){
						timeout = null;
						showHide();
					},transition);
				}
			}, function() {
				// Uscita
				if(timeout){
					clearTimeout(timeout);
					timeout = null;
				} else {
					showHide();
				}
			}
		);
	}
});